import React from 'react';

import CircularProgress from 'material-ui/CircularProgress';

import { FormattedMessage } from 'react-intl';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    padding: 24,
    fontSize: 24,
    fontWeight: 300,
  },
};

// eslint-disable-next-line react/prop-types
const Loading = ({ height = '100vh' }) => (
  <div style={{ ...styles.container, height }}>
    <CircularProgress
      size={120}
      style={{ lineHeight: '90px' }}
      mode="indeterminate"
      thickness={4}
    />
    <span style={styles.text}><FormattedMessage id="loading.message" /></span>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js